module.exports = __webpack_public_path__ + "static/media/total-reportee-icon.83a0d3cb.svg";